// Brutalist trust strip — claims separated by hard 2px rules.
// Replaces the previous calm dotted-divider strip.

const claims = [
  '<50ms typical overhead',
  'Encrypted at rest',
  'No token markup',
  'Streaming supported',
];

export default function TrustStrip() {
  return (
    <section className="border-y-2 border-border bg-card/40">
      <div className="container-ledger py-5">
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground font-bold">
          {claims.map((claim, index) => (
            <li key={claim} className="flex items-center gap-3">
              <span aria-hidden className="w-1.5 h-1.5 bg-spray-yellow inline-block" />
              {claim}
              {index < claims.length - 1 && (
                <span aria-hidden className="hidden sm:inline-block w-3 h-px bg-border ml-3" />
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
